export default {"src":"https://marketplace-web-assets.vinted.com/_next/static/media/symbol.75ea2eb4.svg","height":44,"width":70,"blurWidth":0,"blurHeight":0};